/* eslint-disable react/display-name */
import React from 'react';
import { Messages } from '../../../../../../gen-src/Localize';
import { TypedBodyCellProps, TypedColumn, UnsortableColumnKey } from '../../dataGrid/TypedDataGridInterfaces';
import { createSortableHeaderFormatter } from '../../dataGrid/headerFormatters/SortableHeaderFormatter';
import { GridSortProps } from '../../dataGrid/sort/GridSortProps';
import { SiteUrlsContext } from '../../urls/SiteUrlsContext';
import { ChipCellWrapper } from '../Styles';
import { useRenderLabels, UseRenderLabelsParams } from '../hook/useRenderLabels';
import { LabelCellFormatterParams, LabelColumnFormatterParams } from '../shared/LabelCellFormatterParams';

export function createSensitivityColumnFormatter<T,>({ getPropsFromRowData, overrides }: LabelColumnFormatterParams<T, UseRenderLabelsParams>): TypedColumn<T, ''> {
  return ({
    name: 'label-sensitivity',
    dataKey: UnsortableColumnKey,
    headerText: Messages.ColumnHeaderSensitivity(),
    resizable: false,
    sortable: false,
    growToFit: true,
    headerFormatter: createSensitivityHeaderFormatter(),
    cellFormatter: createSensitivityCellFormatter<T>({ getPropsFromRowData }),
    ...overrides,
  });
}

type SensitivitySortParams = Partial<GridSortProps<''>>;

function createSensitivityHeaderFormatter() {
  const sortParams: SensitivitySortParams = {};
  return createSortableHeaderFormatter(sortParams);
}

function createSensitivityCellFormatter<T>({ getPropsFromRowData }: LabelCellFormatterParams<T, UseRenderLabelsParams>): React.Factory<TypedBodyCellProps<T>> {
  return (cellFormatterProps: TypedBodyCellProps<T>) => {
    const props: UseRenderLabelsParams = getPropsFromRowData(cellFormatterProps.row.data);
    return <SensitivityCellFormatter {...props} />
  }
}

function SensitivityCellFormatter(props: UseRenderLabelsParams): JSX.Element {
  const siteUrls = React.useContext(SiteUrlsContext);
  const { sensitivities } = useRenderLabels({
    controls: { kind: 'chip', siteUrls: (props.controls && 'siteUrls' in props.controls) ? props.controls?.siteUrls : siteUrls },
    ...props
  });
  return (
    <ChipCellWrapper>
      {sensitivities}
    </ChipCellWrapper>
  )
}
